<template>
    <article class="homepage">
        <button @click="handleCloseIframe" type="button" class="homepage__close">{{ translate("ui.mobile.cancel.btn", "Cancel payment")}}</button>
        <payment-header
            :customer="checkoutData.customer"
            :merchant="checkoutData.merchant"
            :currency="checkoutData.currency.current"
            :amount="amount"
            :method="checkoutData.method.current"
        />
        <h2 class="homepage__title">{{translate("ui.mobile.title", "How would you like to pay?")}}</h2>
    </article>
</template>

<script>
import PaymentHeader from "../payment-header.vue";
import { ref, onBeforeUnmount } from "vue";
import { injectStore } from "redux-vuex";

export default {
    name: "MobileHomepage",
    components: { PaymentHeader },
    props: {
        amount: {
            type: String,
            required: true,
        },
    },
    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        onBeforeUnmount(() => {
            subscription();
        });

        function handleCloseIframe(state) {
            store.Control.close(state);
        }

        return { handleCloseIframe, checkoutData };
    },
};
</script>

<style lang="scss" scoped>
.homepage {
  padding: 2rem 2.4rem;
  @media screen and (min-width: $breakpoint-middle * 1px) {
    display: none;
  }
  &__close {
    position: relative;
    background: $white;
    border: none;
    padding: 0;
    font-size: 1.4rem;
    line-height: 1.6rem;
    color: $red;
    margin: 0;
    margin-bottom: 2rem;
    font-weight: $font-semi-bold;
    padding-top: 0.2rem;
  }
  &__title {
    margin-top: 7vh;
    font-size: 2.4rem;
    font-weight: $font-medium;
    color: $primary-text-color;
    @include screen (small){
      margin-top: 3rem;
      font-size: 2.2rem;
      line-height: 2.6rem;
    }
    @media screen and (max-width: 360px) and (min-height: 700px){
      margin-top: 10vh;
      font-size: 2.6rem;
      padding-right: 12rem;
    }
    @media screen and (min-width: 375px) and (min-height: 700px) {
      margin-top: 10vh;
      font-size: 2.6rem;
      line-height: 3rem;
      margin-bottom: 4.2rem;
      padding-right: 12rem;
    }
     @media screen and (min-width: 375px) and (min-height: 812px) and (-webkit-device-pixel-ratio: 3) {
      margin-top: 8vh;
    }
  }
}
 .homepage .header{
  padding: 0;
}
</style>